import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  window.location.href = '/404';
  return (
    <>
      {/* <Link to={{pathname: "/Pay"}}>Pay</Link>
      <br />
      <Link to={{pathname: "/TK"}}>Ticket</Link>
      <br />
      <Link to={{pathname: "/PayCard"}}>PayCard</Link>
      <br />
      <Link to={{pathname: "/PayPix"}}>PayPix</Link>
      <br />
      <Link to={{pathname: "/ViewTicket"}}>ViewTicket</Link>
      <br />
      <Link to={{pathname: "/Receipt"}}>Receipt</Link>
      <br /> */}
    </>
  );
}

export default Home;
